export default function() {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;

  $(`#${widgetName}`).append('<iframe></iframe>');
  $(`#${widgetName}`).wrap('<div id="videoSection"><div class="videoSectionInner"></div></div>');

  $(`#${widgetName}`).videoWidget({
      scriptPath: widgetOpts.scriptPath
      , currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID
      , detectIpad: IPADDETECTED
      // options
      , multiVideo: true
      , videoPaginate: true
      , showOnMobile: true
      , maxVideos: 6
      , trackingGA: {
        present: false,
        event: 'event',
        gaObj: {
          eventCategory: 'Videos',
          eventAction: '',
          eventLabel: '',
        }
      }
      , videoWidgetLoaded: function(data){
        console.log(data);
        $(`#${widgetName} #arrow-container`).appendTo('#videoSection');
        $(`#videoSection .video-arrow`).append('<div></div>');
      }
  });

};
